import { useEffect, useState } from "react";
import { TextAreaInput } from "swing-components";
import { translate } from "utils/string-table";

import {
  ModalSubFeedbackBody,
  ModalSubFeedbackFooter,
  ModalSubFeedbackHeader,
  NegativeData,
  NegativeStep,
} from "~components/ModalSubFeedback";

/********* Types ********/
type ModalSubFeedbackContentNegativeCommentsProps = {
  negativeData: NegativeData;
  onDismiss: () => void;
  onSubmit: (data: NegativeData) => void;
  setNegativeData: (data: NegativeData) => void;
  setNegativeStep: (step: NegativeStep) => void;
  subName?: string;
  hasSubmissionError?: boolean;
};

export function ModalSubFeedbackContentNegativeComments(
  props: ModalSubFeedbackContentNegativeCommentsProps,
) {
  const {
    negativeData,
    onDismiss,
    setNegativeData,
    setNegativeStep,
    subName,
    onSubmit: submitSubFeedbackForm,
    hasSubmissionError,
  } = props;

  /********* Hooks ********/
  const [_updatedComment, _setUpdatedComment] = useState(negativeData.comment);

  useEffect(() => {
    if (hasSubmissionError === false) setNegativeStep("summary");
  }, [hasSubmissionError, setNegativeStep]);

  /********* Handlers ********/
  function handleOnCommentChange(comment: string) {
    _setUpdatedComment(comment);
  }

  function handleOnSubmit() {
    const updatedData = { ...negativeData, comment: _updatedComment };

    setNegativeData(updatedData);
    submitSubFeedbackForm(updatedData);
  }

  return (
    <>
      <ModalSubFeedbackHeader title={translate("GIVE_FEEDBACK_LABEL")} onDismiss={onDismiss} />
      <ModalSubFeedbackBody hasApiError={hasSubmissionError}>
        <div css={{ padding: "8px 0" }}>
          <TextAreaInput
            label={translate("MSF_NEGATIVE_NEUTRAL_FEEDBACK_COMMENT_LABEL", subName)}
            subLabel={translate(
              "MSF_NEGATIVE_NEUTRAL_FEEDBACK_COMMENT_PUBLIC_SHARING_NOTE",
              subName,
            )}
            value={_updatedComment}
            onChange={(comment: string) => handleOnCommentChange(comment)}
            placeholder={translate("MSF_COMMENT_TEXT_INPUT_PLACEHOLDER")}
            isRequired
          />
        </div>
      </ModalSubFeedbackBody>
      <ModalSubFeedbackFooter
        buttonPrimary={{
          onClick: handleOnSubmit,
          isDisabled: !_updatedComment.trim(),
          text: translate("LABEL_SUBMIT"),
        }}
        buttonSecondary={{
          onClick: () => {
            // Save the current comment before navigating back
            // Do not check if it's empty, if they cleared the
            // comment before navigating back, we would like to
            // keep that empty state.
            setNegativeData({ ...negativeData, comment: _updatedComment });
            setNegativeStep("reasons");
          },
          isDisabled: false,
          text: translate("LABEL_BACK"),
        }}
      />
    </>
  );
}
